import styled from "@emotion/styled";
import { css } from "@emotion/core";
import { NectarTheme } from "@nectarTypes";

export const ModalContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 327px;
    background-color: ${theme.colors.white};
    padding: ${theme.spacings.lg};
    row-gap: ${theme.spacings.lg};
    border-radius: ${theme.spacings.xs};
    z-index: 11;
    word-break: break-word;

    #close-modal-icon {
      display: none;
    }

    ${theme.breakpoints.sm} {
      width: 640px;

      #close-modal-button {
        display: none;
      }
      #close-modal-icon {
        display: flex;
      }
    }
  `}
`;

export const BlackScreen = styled.div<NectarTheme & { isOn: boolean }>`
  ${({ theme, isOn }) => css`
    background-color: ${isOn ? theme.colors.black + 70 : "transparent"};
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    z-index: 10;
    overflow: auto;
    padding-top: 50px;
    padding-bottom: 50px;
    min-height: 100dvh;
    height: 100%;
    width: 100dvw;
  `}
`;

export const IconContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    padding: ${theme.spacings.xs};
    color: ${theme.colors.white};
    width: fit-content;
    margin-left: auto;
    cursor: pointer;
    & :hover {
      color: ${theme.colors.primary};
    }
  `}
`;
